import { IProjectMake, RatingData } from './projectMake.d';

export const RATING_WEIGHTS = {
  cutExpectation: 0.25,
  cutQuality: 0.25,
  correctFileInfo: 0.2,
  coolFactor: 0.3,
};

/** Weighted 0-5 score for one make, or null if any component rating is missing. */
export function weightedRating(ratings?: RatingData): number | null {
  if (!ratings) return null;

  const entries = Object.entries(RATING_WEIGHTS);
  const isValid = entries.every(([key]) => {
    const value = ratings[key as keyof RatingData];
    return typeof value === 'number' && !Number.isNaN(value);
  });
  if (!isValid) return null;

  const total = entries.reduce(
    (sum, [key, weight]) => sum + ratings[key as keyof RatingData] * weight,
    0
  );

  const rounded = Math.round(total * 10) / 10;
  return rounded > 0 ? rounded : null;
}

/** Mean weighted rating across the makes that have one, or null if none do. */
export function averageRating(makes: IProjectMake[]): number | null {
  const rated = makes
    .map((make) => weightedRating(make.ratings))
    .filter((rating): rating is number => rating !== null);

  if (rated.length === 0) return null;
  const mean = rated.reduce((sum, rating) => sum + rating, 0) / rated.length;
  return Math.round(mean * 10) / 10;
}
